import {WechatInitOptions, WechatTextMsg, WechatFileMsg, MediaType, File} from "../../base/options";
import * as rp from "request-promise";
import * as fs from "fs";
import {WechatService} from "../wechatservice";
import {AppTokenService} from "../../token/apptokenservice";
import {TokenService} from "../../token/tokenservice";

/**
 * 企业微信 素材 服务
 */
export class MediaService {

  /*
   * 上传临时素材
   * */
  static async uploadTempMedia(type: MediaType, file: File): Promise<any> {
    let wechatOptions: WechatInitOptions = await WechatService.getWechatOptions();
    let tokenService: TokenService = new AppTokenService();
    let accessToken: string = await tokenService.getAccessToken();
    let param: any = {
      method: "POST",
      uri: `${wechatOptions.corp.apiUrl}media/upload?access_token=${accessToken}&type=${type}`,
      formData: {
        file: file
      },
      json: true
    };

    let result: any = await rp(param);

    if (!result.errcode) {
      delete result.errcode;
      delete result.errmsg;

      return result;
    } else {
      console.error(`upload failed , response:`);
      console.error(result);
    }

    return "";
  }

}
